// extracted by mini-css-extract-plugin
export default {"endScreen":"_2wbLXrjB","contents":"_3pBnqrJn","savesEducator":"_3US5MAvH"};